import ContactOverview from '../features/contact-management/contact-overview/contact-overview';
import TagManagement from '../features/contact-management/tag-management/tag-management';
import React, { useEffect } from 'react';
import useAppBarNavigationStore, { NavigationStates } from 'stores/app-bar-navigation-store';

const ContactManagement: React.FC = () => {
  const appBarNavigation = useAppBarNavigationStore((state) => state.activeTab);
  const setActiveTab = useAppBarNavigationStore((state) => state.setActiveTab);

  // Default to the contact overview tab when entering the page so we load the
  // contacts straight away instead of rendering an empty page when the globally
  // persisted activeTab still points at a previous page's tab.
  useEffect(() => {
    setActiveTab(NavigationStates.TOOL);
  }, [setActiveTab]);

  return (
    <>
      {appBarNavigation === NavigationStates.TOOL ? (
        <ContactOverview />
      ) : appBarNavigation === NavigationStates.TAG_MANAGEMENT ? (
        <TagManagement />
      ) : null}
    </>
  );
};

export default ContactManagement;